import React, { useState } from 'react';

/* ── Estilos inline para evitar conflictos con App.css (.modal-overlay y .modal-content
      están redefinidos ahí como side-panel, lo que rompe este modal centrado) ── */

const S = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    pointerEvents: 'auto',
    backdropFilter: 'blur(2px)',
  },
  container: {
    width: '100%',
    maxWidth: '460px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
    overflow: 'hidden',
    animation: 'mnp-slide 0.25s ease',
  },
  header: {
    background: 'linear-gradient(135deg, #111827 0%, #2d4a6d 100%)',
    padding: '20px 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    borderBottom: 'none',
  },
  headerTitle: {
    margin: 0,
    fontSize: '17px',
    fontWeight: 700,
    color: '#ffffff',
    letterSpacing: '-0.2px',
  },
  headerSub: {
    margin: '4px 0 0',
    fontSize: '12px',
    color: 'rgba(255,255,255,0.6)',
  },
  closeBtn: {
    background: 'rgba(255,255,255,0.15)',
    border: 'none',
    color: '#ffffff',
    fontSize: '16px',
    lineHeight: 1,
    cursor: 'pointer',
    padding: '6px 8px',
    borderRadius: '6px',
    transition: 'background 0.15s',
    flexShrink: 0,
  },
  body: {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    background: '#ffffff',
  },
  errorBox: {
    padding: '10px 14px',
    background: '#fef2f2',
    border: '1px solid #fecaca',
    borderRadius: '8px',
    color: '#dc2626',
    fontSize: '13px',
    marginBottom: '-4px',
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#374151',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    color: '#111827',
    fontSize: '14px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.15s, box-shadow 0.15s',
  },
  textarea: {
    width: '100%',
    padding: '10px 14px',
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    color: '#111827',
    fontSize: '14px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    outline: 'none',
    resize: 'vertical',
    minHeight: '80px',
    transition: 'border-color 0.15s, box-shadow 0.15s',
  },
  plantillaBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '14px 16px',
    background: '#f9fafb',
    border: '1px solid #e5e7eb',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  checkbox: {
    marginTop: '2px',
    width: '15px',
    height: '15px',
    flexShrink: 0,
    cursor: 'pointer',
    accentColor: '#111827',
  },
  plantillaTitle: {
    margin: 0,
    fontSize: '13px',
    fontWeight: 600,
    color: '#111827',
  },
  plantillaDesc: {
    margin: '3px 0 0',
    fontSize: '12px',
    color: '#6b7280',
    lineHeight: 1.4,
  },
  footer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderTop: '1px solid #f3f4f6',
    background: '#f9fafb',
  },
  cancelBtn: {
    padding: '9px 20px',
    background: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    color: '#374151',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'border-color 0.15s, background 0.15s',
  },
  submitBtn: (disabled) => ({
    padding: '9px 24px',
    background: disabled ? '#e5e7eb' : '#111827',
    border: 'none',
    borderRadius: '8px',
    color: disabled ? '#9ca3af' : '#ffffff',
    fontSize: '14px',
    fontWeight: 700,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.15s',
    boxShadow: disabled ? 'none' : '0 2px 8px rgba(0,0,0,0.25)',
  }),
};

const focusStyle = { borderColor: '#9ca3af', boxShadow: '0 0 0 3px rgba(17,24,39,0.08)', background: '#ffffff' };
const blurStyle  = { borderColor: '#e5e7eb', boxShadow: 'none', background: '#f9fafb' };

const ModalNuevoProyecto = ({ visible, onCerrar, onCrear }) => {
  const [nombre, setNombre]                 = useState('');
  const [manager, setManager]               = useState('');
  const [descripcion, setDescripcion]       = useState('');
  const [aplicarPlantilla, setAplicarPlantilla] = useState(true);
  const [cargando, setCargando]             = useState(false);
  const [error, setError]                   = useState('');
  const [focused, setFocused]               = useState('');

  if (!visible) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nombre.trim()) { setError('El nombre del proyecto es requerido'); return; }
    setCargando(true);
    setError('');
    try {
      await onCrear(nombre.trim(), manager.trim(), descripcion.trim(), aplicarPlantilla);
      setNombre(''); setManager(''); setDescripcion(''); setAplicarPlantilla(true);
      onCerrar();
    } catch (err) {
      setError(err.mensaje || err.error || err.message || 'Error al crear el proyecto');
    } finally {
      setCargando(false);
    }
  };

  const handleCerrar = () => {
    if (cargando) return;
    setNombre(''); setManager(''); setDescripcion(''); setError('');
    onCerrar();
  };

  const inputStyle  = (field) => ({ ...S.input,    ...(focused === field ? focusStyle : blurStyle) });
  const taStyle     = (field) => ({ ...S.textarea,  ...(focused === field ? focusStyle : blurStyle) });

  return (
    <>
      <style>{`
        @keyframes mnp-slide {
          from { opacity: 0; transform: translateY(-16px) scale(0.98); }
          to   { opacity: 1; transform: translateY(0)     scale(1);    }
        }
      `}</style>

      <div style={S.overlay} onClick={handleCerrar}>
        <div style={S.container} onClick={e => e.stopPropagation()}>

          {/* Header */}
          <div style={S.header}>
            <div>
              <h2 style={S.headerTitle}>Nuevo Proyecto</h2>
              <p style={S.headerSub}>Ingresa los datos del proyecto de construcción</p>
            </div>
            <button
              type="button"
              style={S.closeBtn}
              onClick={handleCerrar}
              disabled={cargando}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
            >✕</button>
          </div>

          <form onSubmit={handleSubmit}>
            <div style={S.body}>

              {error && <div style={S.errorBox}>{error}</div>}

              {/* Nombre */}
              <div style={S.fieldGroup}>
                <label style={S.label}>Nombre del Proyecto *</label>
                <input
                  style={inputStyle('nombre')}
                  type="text"
                  value={nombre}
                  onChange={e => setNombre(e.target.value)}
                  onFocus={() => setFocused('nombre')}
                  onBlur={() => setFocused('')}
                  placeholder="Ej: Edificio Norte"
                  maxLength={200}
                  disabled={cargando}
                  autoFocus
                />
              </div>

              {/* Gerente */}
              <div style={S.fieldGroup}>
                <label style={S.label}>Gerente de Proyecto</label>
                <input
                  style={inputStyle('manager')}
                  type="text"
                  value={manager}
                  onChange={e => setManager(e.target.value)}
                  onFocus={() => setFocused('manager')}
                  onBlur={() => setFocused('')}
                  placeholder="Ej: Juan Pérez"
                  maxLength={100}
                  disabled={cargando}
                />
              </div>

              {/* Descripción */}
              <div style={S.fieldGroup}>
                <label style={S.label}>Descripción</label>
                <textarea
                  style={taStyle('descripcion')}
                  value={descripcion}
                  onChange={e => setDescripcion(e.target.value)}
                  onFocus={() => setFocused('descripcion')}
                  onBlur={() => setFocused('')}
                  placeholder="Descripción opcional del proyecto..."
                  maxLength={1000}
                  rows={3}
                  disabled={cargando}
                />
              </div>

              {/* Plantilla */}
              <label style={S.plantillaBox}>
                <input
                  type="checkbox"
                  style={S.checkbox}
                  checked={aplicarPlantilla}
                  onChange={e => setAplicarPlantilla(e.target.checked)}
                  disabled={cargando}
                />
                <div>
                  <p style={S.plantillaTitle}>Aplicar plantilla predeterminada</p>
                  <p style={S.plantillaDesc}>
                    Crea automáticamente los 95 subcontratos y 153 materiales estándar
                  </p>
                </div>
              </label>

            </div>

            {/* Footer */}
            <div style={S.footer}>
              <button
                type="button"
                style={S.cancelBtn}
                onClick={handleCerrar}
                disabled={cargando}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#9ca3af'; e.currentTarget.style.background = '#f3f4f6'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#d1d5db'; e.currentTarget.style.background = '#ffffff'; }}
              >
                Cancelar
              </button>
              <button
                type="submit"
                style={S.submitBtn(cargando || !nombre.trim())}
                disabled={cargando || !nombre.trim()}
              >
                {cargando ? 'Creando...' : 'Crear Proyecto'}
              </button>
            </div>
          </form>

        </div>
      </div>
    </>
  );
};

export default ModalNuevoProyecto;
